/*global angular*/
'use strict'

angular.module('whirlwind').directive('wwUnsupportedMessage', function () {
  return {
    replace: true,
    templateUrl: 'components/ww-unsupported-message/ww-unsupported-message.html'
  }
})
